module.exports = __webpack_public_path__ + "static/img/case3-bg.c5a32f2.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/homePage/case3-bg.webp
// module id = wnFj
// module chunks = 0